import { GalleryLayoutMode } from '../components/JustifiedGallery'

const GROUP_BY_DATE_COOKIE = 'gallery_group_by_date'
const LAYOUT_COOKIE = 'gallery_layout'
const COOKIE_MAX_AGE_DAYS = 365

const readCookie = (name: string): string | undefined => {
  try {
    return document.cookie
      .split('; ')
      .find((part) => part.startsWith(`${name}=`))
      ?.split('=')[1]
  } catch {
    return undefined
  }
}

const writeCookie = (name: string, value: string): void => {
  try {
    const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60
    document.cookie = `${name}=${value}; max-age=${maxAge}; path=/`
  } catch {
    // cookie storage unavailable — the preference just won't persist
  }
}

export const getGroupByDatePreference = (): boolean =>
  readCookie(GROUP_BY_DATE_COOKIE) !== 'false'

export const setGroupByDatePreference = (value: boolean): void =>
  writeCookie(GROUP_BY_DATE_COOKIE, String(value))

export const getLayoutPreference = (): GalleryLayoutMode =>
  readCookie(LAYOUT_COOKIE) === 'masonry' ? 'masonry' : 'justified'

export const setLayoutPreference = (value: GalleryLayoutMode): void =>
  writeCookie(LAYOUT_COOKIE, value)
